// Carousel config object
const carouselConfig = {
    component: 'Tabs',
    init: true,
    hasMousewheel: true,
    hasNavigation: true,
    hasBreakpoints: true,
    hasLazy: false,
    isMulti: true,
    swiper: {
        init: true,
        // Default parameters
        slidesPerView: 6,
        slidesPerGroup: 6,
        watchSlidesVisibility: true,
        loop: false,
        spaceBetween: 0,
        mousewheel: {
            sensitivity: 0.1
        },
        speed: 500,
        autoplay: false,
        // Setting class names
        containerModifierClass: 'tabs-carousel--',
        slideClass: 'tabs-carousel__slide',
        slideActiveClass: 'tabs-carousel__slide--active',
        slideVisibleClass: 'tabs-carousel__slide--visible',
        slideNextClass: 'tabs-carousel__slide--next',
        slidePrevClass: 'tabs-carousel__slide--prev',
        wrapperClass: 'tabs-carousel__wrapper',

        // Responsive breakpoints
        breakpoints: {
            // when window width is <= 480px
            768: {
                slidesPerView: 2,
                slidesPerGroup: 2
            },
            // when window width is <= 720px
            1200: {
                slidesPerView: 3,
                slidesPerGroup: 3
            },

            // when window width is <= 1600px
            1600: {
                slidesPerView: 5,
                slidesPerGroup: 5
            }
        },

        // Navigation
        navigation: {
            nextEl: '.tabs-carousel__navigation--next',
            prevEl: '.tabs-carousel__navigation--prev',
            hiddenClass: 'tabs-carousel__navigation--hidden',
            disabledClass: 'tabs-carousel__navigation--disabled'
        },
        pagination: {},
        lazy: {}
    }
};

module.exports = carouselConfig;
